import React from 'react';
import { Button } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";



export default (formPlugin, namespace) =>
{
    const POSITION_VERTICAL = [
        `Haut`,
        `Milieu`,
        `Bas`
    ]

    const POSITION_HORIZONTAL = [
        `Gauche`,
        `Centre`,
        `Droite`
    ]

    return {
        Renderer: (props) => {
            const { data } = props

            let alignItems = "flex-end"
            let justifyContent = "flex-end"

            switch (data.vertical_position) {
                case POSITION_VERTICAL[0]:
                    alignItems = "flex-start"
                    break;
                case POSITION_VERTICAL[1]:
                    alignItems = "center"
                    break;
                case POSITION_VERTICAL[2]:
                    alignItems = "flex-end"
                    break;
            }

            switch (data.horizontal_position) {
                case POSITION_HORIZONTAL[0]:
                    justifyContent = "flex-start"
                    break;
                case POSITION_HORIZONTAL[1]:
                    justifyContent = "center"
                    break;
                case POSITION_HORIZONTAL[2]:
                    justifyContent = "flex-end"
                    break;
            }

            const style = { display: "flex", alignItems: alignItems, justifyContent: justifyContent }
            const buttonStyle = { display: "flex", justifyContent: "center", alignItems: "center" }

            if (data.height) {
                buttonStyle.height = data.height
            }

            if (data.width) {
                buttonStyle.width = data.width
            }

            if (data.fontSize) {
                buttonStyle.fontSize = data.fontSize
            }

            if (data.backgroundColor) {
                buttonStyle.backgroundColor = data.backgroundColor
                buttonStyle.borderColor = data.backgroundColor
            }

            return (
                <div style={style}>
                    <Button
                        style={buttonStyle}
                        type="primary"
                        htmlType="submit"
                    >
                        {data.label || <Trans>Valider</Trans>}
                    </Button>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-submit-button' + namespace,
        title: t`Bouton Validation`,
        description: t`Élément de formulaire utilisable.`,
        icon: <SendOutlined />,
        iconColor: "#F39C12",
        version: 1,
        hideInMenu: formPlugin.formData.type !== "COMPLEX",
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    vertical_position: {
                        type: "string",
                        uniforms: {
                            showIf: () => false,
                            label: t`Positionnement Vertical`,
                            allowedValues: POSITION_VERTICAL,
                        }
                    },
                    horizontal_position: {
                        type: "string",
                        uniforms: {
                            label: t`Positionnement Horizontal`,
                            allowedValues: POSITION_HORIZONTAL,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            label: t`Titre`,
                            placeholder: t`Envoyer`,
                        }
                    },
                    width: {
                        type: 'number',
                        uniforms: {
                            label: t`Largeur`,
                            placeholder: t`pixel`,
                        }
                    },
                    height: {
                        type: 'number',
                        uniforms: {
                            label: t`Hauteur`,
                            placeholder: t`pixel`,
                        }
                    },
                    fontSize: {
                        type: 'number',
                        uniforms: {
                            label: t`Taille de police`,
                            placeholder: t`pixel`,
                        }
                    },
                    backgroundColor: {
                        type: "string",
                        uniforms: {
                            label: t`Couleur de fond`,
                            placeholder: t`#000000 / rgba(0,0,0,0)`,
                        }
                    },
                }
            },
        },
    }
}
